define(function(require) {
    'use strict';
    var AppConfig = require('config/application');
    var Backbone = require('backbone');

    return Backbone.Model.extend({
        urlRoot: AppConfig.host + '/rest/templates',
        parse: function (response) {
            if (response.result !== undefined) {
                return response.result;
            } else {
                return response;
            }
        }
    });
});